import * as TypeAction from './actionTypes'
import { actionSyncListObj} from 'scorpion-core';
import { listarAllPefis } from './api';



export const listar = () => (dispatch) => {
    listarAllPefis(actionSyncListObj(TypeAction.LISTAR, dispatch));
}




// WEBPACK FOOTER //
// ./src/routes/admin/ConsultaPerfisAdmin/actions.js